import { render, staticRenderFns } from "./CatalogPage.vue?vue&type=template&id=62c6a31e&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"
import style0 from "./CatalogPage.vue?vue&type=style&index=0&id=62c6a31e&prod&lang=scss&scoped=true"
import style1 from "./CatalogPage.vue?vue&type=style&index=1&id=62c6a31e&prod&lang=css"
import style2 from "./CatalogPage.vue?vue&type=style&index=2&id=62c6a31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c6a31e",
  null
  
)

export default component.exports